import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'cargoes-medical-details',
  templateUrl: './medical-details.component.html',
})
export class MedicalDetailsComponent implements OnInit {

  medicalDetailsGroup!: FormGroup;
  medicalStatusList: any[] = [];
  formData = { "variables": {
    "medicalRefNo":{},
    "medicalStatus":{},
    "remarks":{}
  } };
  load = false;
  @Input() defaultFormData: any;
  @Output() submitedFormData = new EventEmitter<any>();

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    if (typeof this.defaultFormData === 'object') {
      this.onLoad(this.defaultFormData);
      this.load = true;
    }
  }

  onLoad(data: any) {
    this.medicalDetailsGroup = this.formBuilder.group({
      medicalStatus: [null, [Validators.required]],
      medicalRefNo: [null, [Validators.required]],
      remarks: [null]
    });

    let keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
       if (key.indexOf('status') >= 0) {
        this.medicalStatusList = data.rdmData[key];
      }
    });
  }

  onSubmit() {
    for (const i in this.medicalDetailsGroup.controls) {
      this.medicalDetailsGroup.controls[i].markAsDirty();
      this.medicalDetailsGroup.controls[i].updateValueAndValidity();
    }

    if (this.medicalDetailsGroup.value.medicalRefNo !== null) {
      this.formData.variables['medicalRefNo'] = {"value" : this.medicalDetailsGroup.value.medicalRefNo  }
    }

    if (this.medicalDetailsGroup.value.medicalStatus !== null) {
      this.formData.variables['medicalStatus'] = {"value" : this.medicalDetailsGroup.value.medicalStatus }
    }

    if (this.medicalDetailsGroup.value.remarks !== null) {
      this.formData.variables['remarks'] = {"value" : this.medicalDetailsGroup.value.remarks }
    }

    if (this.medicalDetailsGroup.valid) {
      this.submitedFormData.emit(this.formData);
    }

  }


}
